export const labelListStyle: React.CSSProperties = {
  textAnchor: 'middle',
  fontSize: '12px',
  fontWeight: 'bold',
  fill: '#808080',
};
